import GeneratedHttpThunk from 'utility/redux/generatedHttpThunk';

const edcSummaryCardsHttpRequest = (() => {
  const apiName = 'edcSummaryCards';
  const generatedHttpThunk = new GeneratedHttpThunk(apiName);
  generatedHttpThunk.resource = `trial-management/edc-summary-cards/trial/:trialId`;
  return generatedHttpThunk.generateTrialThunk();
})();

export default edcSummaryCardsHttpRequest;
